import React from 'react';
import s from './index.module.scss';
import DefaultOption from '../defaultOption';

function DefaultQuestion (props) {
	const { options } = props.step;
	const { name } = props.step;

	return (
		<section className={s.defaultStep}>
			<h2 className={s.title}>{name}</h2>

			<div className={s.options}>
				{
					options && Object.entries(options).map((option) => (
						<DefaultOption
							key={option[1].value}
							className={s.option}
							selectedStateClass={s.optionSelected}
							option={option[1]}
							questionName={name}
						>
							{option[1].value}
						</DefaultOption>
					))
				}
			</div>
		</section>
	);
}

export default DefaultQuestion;
